import { ReactComponent as Icon } from "../files/Microphone.svg";

import ISVGIconProps from "../ISVGIconProps";

const MicrophoneIcon = ({
    fill,  
    style = {},
}: ISVGIconProps) => {   
    return (
        <div style={style}>
            <Icon
                fill={fill} 
                style={style}        
            />
        </div>
    );
};

export default MicrophoneIcon;
